/**
 * Plugin Vuex pour invalider automatiquement le cache
 * lors de certaines mutations (création, modification, suppression)
 */
import apiService from '@/services/api.service';

export default function cacheInvalidationPlugin(store) {
  store.subscribe((mutation) => {
    const { type } = mutation;

    // Mapping des mutations vers les patterns de cache à invalider
    const invalidationMap = {
      // Déconnexion : vider tout le cache
      'DESTROY_SESSION_USER': () => {
        apiService.clearCache();
        console.log('🗑️ Cache vidé suite à la déconnexion');
      },

      // Mise à jour du token : pas besoin d'invalider le cache
      'updateToken': () => {
        // Ne rien faire, le cache reste valide
      },

      // Ajoutez ici d'autres mutations qui nécessitent une invalidation
      // Exemple :
      // 'CREATE_OFFER': () => apiService.invalidateCache('offreVoyage'),
      // 'UPDATE_OFFER': () => apiService.invalidateCache('offreVoyage'),
      // 'DELETE_OFFER': () => apiService.invalidateCache('offreVoyage'),
    };

    // Exécuter l'invalidation si la mutation est mappée
    const invalidationFn = invalidationMap[type];
    if (invalidationFn) {
      invalidationFn();
    }
  });
}
